'use es6';

import { PropTypes } from 'prop-types';
export default PropTypes.shape({
  onThreadTrackingContextChange: PropTypes.func
});